import React from "react";
import styles from "./MainCard.module.css";

export default function MainCard({ card, isSelected, onClick, className }) {
  return (
    <div
      className={`${styles.mainCard} ${styles[className] || ""} ${
        isSelected ? styles.selected : ""
      }`}
      onClick={onClick}
    >
      <div className={styles.cardIcon}>{card.icon}</div>
      <h3 className={styles.cardTitle}>{card.title}</h3>
      <p className={styles.cardSummary}>{card.summary}</p>
    </div>
  );
}
